// extracted by mini-css-extract-plugin
export default {"game":"TeamGame_game__j4SzC","title":"TeamGame_title__9C9jb"};